import { TextField, ValidationErrors } from "@compass/core";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker as MuiTimePicker } from "@mui/x-date-pickers/TimePicker";
import { TimePickerProps as MuiTimePickerProps } from "@mui/x-date-pickers/TimePicker";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import { useEffect, useState } from "react";
import { displayErrorMessages, getErrorMessages } from "../common/input-functions";

export type TimePickerBaseProps = Omit<MuiTimePickerProps<Date, Date>, "value" | "onChange" | "renderInput"> & {
  label?: string;
  value?: any;
  onChange?: (date: any | undefined, keyboardInputValue?: string) => void;
  errors?: ValidationErrors | string[];
  required?: boolean;
  size?: "small" | "medium" | undefined;
  disabled?: boolean;
  autoFocus?: boolean;
};

// export class UTCUtils extends MomentUtils {
//   format = (value, formatString) => {
//     return moment(value).utc().format(formatString);
//   };
// }

export const TimePickerBase = ({
  label,
  value,
  onChange,
  size = "medium",
  errors,
  required,
  disabled,
  autoFocus,
  ...rest
}: TimePickerBaseProps) => {
  const errorMsg = getErrorMessages(errors);
  const hasError = errorMsg?.length > 0 ? true : false;

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <MuiTimePicker
        label={label}
        value={value ? moment(`0001-01-01T${value}`).toDate() : null}
        onChange={(timeValue) => onChange?.(timeValue ? moment(timeValue).format("HH:mm:00") : undefined)}
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            required={required}
            variant={"outlined"}
            error={params.error ? params.error : hasError}
            helperText={displayErrorMessages(errorMsg)}
            size={size}
            autoComplete="off"
            autoFocus={autoFocus}
          />
        )}
      />
    </LocalizationProvider>
  );
};
